import { faSatellite } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav } from 'react-bootstrap';
import styles from './RSCatalogSatelliteNav.module.css';

type Props = {
  satellites: {
    name: string;
    targets: {
      name: string;
      count: number;
    }[];
  }[];
  target: string | null;
  defaultActiveSatellite: string;
  onSelect: (eventKey: string | null) => void;
};

export const RSCatalogSatelliteNav = ({ satellites, target, defaultActiveSatellite, onSelect }: Props) => {
  const countCaluculatedSatellites = target
    ? satellites
        .map((s) => ({ name: s.name, count: s.targets.find((t) => t.name === target)?.count || 0 }))
        .filter((s) => s.count > 0)
    : satellites.map((s) => ({ name: s.name, count: s.targets.reduce((prev, current) => prev + current.count, 0) }));
  return (
    <div className={styles.stickyScrollable}>
      <div className="mb-2">
        <FontAwesomeIcon icon={faSatellite} /> 衛星を選択する
      </div>
      <Nav variant="pills" defaultActiveKey={defaultActiveSatellite} className="flex-md-column" onSelect={onSelect}>
        {countCaluculatedSatellites.map((satellite) => (
          <Nav.Item key={satellite.name}>
            <Nav.Link eventKey={satellite.name}>
              {satellite.name} ({satellite.count})
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
};
